import { createContext, useContext, useState, useEffect } from 'react';
import en from '../translations/en';
import fr from '../translations/fr';

const translations = { en, fr };

const LanguageContext = createContext();

export const LanguageProvider = ({ children, userLanguage = 'en' }) => {
  const [language, setLanguage] = useState(userLanguage);

  useEffect(() => {
    setLanguage(userLanguage);
  }, [userLanguage]);

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && value[k]) {
        value = value[k];
      } else {
        // Fallback to English
        value = translations['en'];
        for (const fallbackKey of keys) {
          if (value && value[fallbackKey]) {
            value = value[fallbackKey];
          } else {
            return key; // Return the key if translation not found
          }
        }
        break;
      }
    }
    
    return value;
  };

  // Helper function to interpolate variables in translation strings
  const tFormat = (key, vars = {}) => {
    let text = t(key);
    Object.keys(vars).forEach(varKey => {
      text = text.replace(`{${varKey}}`, vars[varKey]);
    });
    return text;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, tFormat }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
